import { useState } from "react";
import { Dialog, DialogContent, DialogTitle, Button } from "@mui/material";
import {
  createAssessmentsAPIEndpoint,
  EndPoints,
} from "../../../../services/AssessmentAPI";

const AssessmentStatusToggle = ({
  assessment,
  fetchAssessments,
  page,
  pageSize,
  search,
}) => {
  const [open, setOpen] = useState(false);

  const handleConfirm = () => {
    createAssessmentsAPIEndpoint(EndPoints.toggleAssessmentStatus)
      .putById(assessment.id, {})
      .then(() => {
        fetchAssessments(page, pageSize, search);
        setOpen(false);
      })
      .catch((error) => {
        console.error("Error updating Assessment status:", error);
        setOpen(false);
      });
  };

  const confirmMessage = assessment.isActive
    ? "Are you sure you want to deactivate this Assessment?"
    : "Are you sure you want to activate this Assessment?";

  return (
    <>
      <Button
        variant="outline"
        onClick={() => setOpen(true)}
        className={`btn-toggle-status ${
          assessment.isActive ? "deactivate" : "activate"
        }`}
      >
        {assessment.isActive ? "Deactivate" : "Activate"}
      </Button>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="confirm-dialog">
          <DialogTitle className="confirm-dialog-title">
            Confirm Action
          </DialogTitle>

          <p className="confirm-dialog-message">{confirmMessage}</p>
          <DialogContent className="confirm-dialog-actions">
            <Button
              variant="outline"
              onClick={() => setOpen(false)}
              className="cancel-button"
            >
              Cancel
            </Button>
            <Button
              className={assessment.isActive ? "deactivate" : "activate"}
              onClick={handleConfirm}
            >
              Yes, {assessment.isActive ? "Deactivate" : "Activate"}
            </Button>
          </DialogContent>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default AssessmentStatusToggle;
